<template>
    <!-- Print button -->
    <simple-button
        :icon="!hideButton ? 'print' : ''"
        :loading="printing"
        :look="!hideButton ? 'secondary' : 'text'"
        @click="printStats"
    >
        {{ $t('jobs.stats.print') }}
    </simple-button>
</template>

<script>

import SvgIcon from '../../ui/SvgIcon';
import Loading from '../../ui/Loading.vue';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment';
import SimpleButton from "../../ui/SimpleButton.vue";

export default {
    components: {
        SimpleButton,
        'svg-icon': SvgIcon,
        'loading': Loading,
    },
    data: function () {
        return {
            printing: false,
        };
    },
    props: {
        content: {
            required: true,
            default: String,
        },
        title: {
            required: true,
            default: String,
        },
        hideButton: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        async printStats() {
            //Show loader inside button right away
            this.printing = true;
            this.$emit('printing', true);
            const data = document.getElementById(this.content);

            const answerElements = document.querySelectorAll('#stupid-input');
            const originalTextareas = [];
            // Create div instead of textarea for interviewanswers
            answerElements.forEach((el, index) => {
                const div = document.createElement('div');
                div.id = `temp-div-${index}`; // Temporary ID
                div.style.whiteSpace = 'normal';
                div.style.wordBreak = 'break-word';
                div.style.overflow = 'visible';
                div.style.maxWidth = 'none';
                div.style.padding = window.getComputedStyle(el).padding;
                div.style.fontSize = window.getComputedStyle(el).fontSize;
                div.style.lineHeight = window.getComputedStyle(el).lineHeight;
                div.style.width = '90%';
                div.style.height = el.offsetHeight + 'px';
                div.style.border = window.getComputedStyle(el).border;
                div.textContent = el.value;

                el.parentNode.replaceChild(div, el);
                originalTextareas.push({ el, div });
            });

            if (screen.width < 1024) {
                document.getElementById('viewport').setAttribute('content', 'width=1200px');
            }

            // Remove elements from the div (hide-from-print did not work with previous code on component simple-button)
            const elementsToHide = document.getElementsByClassName('hide-from-print');
            const removedElements = [];
            Array.from(elementsToHide).forEach((element) => {
                const parent = element.parentNode;
                const placeholder = document.createComment('hide-from-print-placeholder');
                parent.replaceChild(placeholder, element);
                removedElements.push({ element, parent, placeholder });
            });

            let res = await html2canvas(data, {
                allowTaint: true,
                removeContainer: true,
                backgroundColor: null,
                imageTimeout: 15000,
                logging: true,
                scale: 2,
                useCORS: true,
            }).then(canvas => {
                // Few necessary setting options
                const contentDataURL = canvas.toDataURL('image/png');
                const imgWidth = 210 - 20; //width A4 - offset sides
                const pageHeight = 295;
                const imgHeight = canvas.height * imgWidth / canvas.width;
                let heightLeft = imgHeight;
                let pdf = new jsPDF('p', 'mm', 'a4', true); // A4 size page of PDF
                let positionX = 10;
                let positionY = 10;

                pdf.addImage(contentDataURL, 'PNG', positionX, positionY, imgWidth, imgHeight, undefined, 'FAST');
                heightLeft -= pageHeight;

                while (heightLeft >= 0) {
                    positionY = heightLeft - imgHeight;
                    pdf.addPage();
                    pdf.addImage(contentDataURL, 'PNG', positionX, positionY, imgWidth, imgHeight, undefined, 'FAST');
                    heightLeft -= pageHeight;
                }
                // Generated PDF
                pdf.save(this.title + '-' + moment().format('DD-MM-YYYY') + '.pdf');

                this.printing = false;
                this.$emit('printing', false);

                window.location.reload();
            });

            // Get the original/removed elements back
            originalTextareas.forEach(({ el, div }) => {
                div.parentNode.replaceChild(el, div);
            });

            removedElements.forEach(({ element, parent, placeholder }) => {
                parent.replaceChild(element, placeholder);
            });

            if (screen.width < 1024) {
                document.getElementById('viewport').setAttribute('content', 'width=device-width, initial-scale=1');
            }

            return res;
        },
    },
    watch: {
        printing: function (value){
            this.$emit('printing', value);
        }
    }
};
</script>
